import React from "react";
import PlatformAnalyticsExperience from "./PlatformAnalyticsExperience";

/*
 * Display Analytics — served by the shared Platform Analytics experience. The
 * route, page title, report-link contract and topline data contract are
 * unchanged; the profile lives in
 * src/platformAnalytics/platformAnalyticsProfiles.js.
 *
 * The inventory-transparency module this page had before the migration is
 * preserved through the profile's distributionTransparencyChannel, and the
 * profile additionally opts the page into Creative Performance because
 * StackAdapt reports Display delivery per creative.
 */
export default function DisplayAnalytics() {
  return <PlatformAnalyticsExperience platformKey="display" />;
}
